module.exports = __webpack_public_path__ + "img/play_rectangle.5a6e8be8.svg";